import React, { useMemo } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import objectPath from 'object-path';
import { useHtmlClassService } from '../../../_core/MetronicLayout';
import { toAbsoluteUrl } from '../../../../_helpers';
import { DropdownTopbarItemToggler } from '../../../../_partials/dropdowns';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

export function QuickActionsDropdown() {
  const bgImage = toAbsoluteUrl('/media/misc/bg-2.jpg');
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, 'extras.quick-actions.layout') ===
        'offcanvas',
    };
  }, [uiService]);

  return (
    <>
      {layoutProps.offcanvas && (
        <OverlayTrigger
          placement='left'
          overlay={
            <Tooltip id='quick-actions-tooltip'>
              <FormattedMessage id='MENU.QUICKACTIONS' />
            </Tooltip>
          }
        >
          <div className='topbar-item'>
            <div
              className='btn btn-icon btn-clean btn-dropdown btn-lg mr-1'
              id='kt_quick_actions_toggle'
            >
              <span className='svg-icon svg-icon-xl svg-icon-primary'>
                <SVG
                  src={toAbsoluteUrl('/media/svg/icons/Code/Compiling.svg')}
                />
              </span>
            </div>
          </div>
        </OverlayTrigger>
      )}
      {!layoutProps.offcanvas && (
        <Dropdown drop='down' alignRight>
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id='kt_quick_actions_panel_toggle'
          >
            <OverlayTrigger
              placement='bottom'
              overlay={
                <Tooltip id='quick-actions-tooltip'>
                  <FormattedMessage id='MENU.QUICKACTIONS' />
                </Tooltip>
              }
            >
              <div className='btn btn-icon btn-hover-transparent-white btn-dropdown btn-lg mr-1'>
                <span className='svg-icon svg-icon-xl'>
                  <SVG
                    src={toAbsoluteUrl('/media/svg/icons/Code/Compiling.svg')}
                  />
                </span>
              </div>
            </OverlayTrigger>
          </Dropdown.Toggle>

          <Dropdown.Menu className='dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg'>
            <form>
              {/* begin: Head */}
              <div
                className='d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top'
                style={{ backgroundImage: `url(${bgImage})` }}
              >
                <h3 className='text-white font-weight-bold font-size-5'>
                  <FormattedMessage id='MENU.QUICKACTIONS' />
                </h3>
                {/*  <span className="btn btn-success btn-sm btn-bold btn-font-md mt-2">
                  23 tasks pending
                </span> */}
              </div>
              {/* end: Head */}

              <div className='row row-paddingless'>
                <div className='col-6'>
                  <NavLink
                    className='d-block py-10 px-5 text-center bg-hover-light border-right border-bottom'
                    to='/orders/new'
                  >
                    <span className='svg-icon svg-icon-3x svg-icon-success'>
                      <SVG
                        src={toAbsoluteUrl(
                          '/media/svg/icons/Shopping/Cart3.svg'
                        )}
                      ></SVG>
                    </span>
                    <span className='d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1'>
                      <FormattedMessage id='ORDER.QUICKACTIONS.TITLE' />
                    </span>
                    <span className='d-block text-dark-50 font-size-sm'>
                      <FormattedMessage id='ORDER.QUICKACTIONS.DESC' />
                    </span>
                  </NavLink>
                </div>
                <div className='col-6'>
                  {/*     <a
                    href="#"
                    className="d-block py-10 px-5 text-center bg-hover-light border-right"
                  > */}
                  <NavLink
                    className='d-block py-10 px-5 text-center bg-hover-light border-right'
                    to='/products/new'
                  >
                    <span className='svg-icon svg-icon-3x svg-icon-success'>
                      <SVG
                        src={toAbsoluteUrl(
                          '/media/svg/icons/Shopping/Gift.svg'
                        )}
                      ></SVG>
                    </span>
                    <span className='d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1'>
                      <FormattedMessage id='PRODUCT.QUICKACTIONS.TITLE' />
                    </span>
                    <span className='d-block text-dark-50 font-size-sm'>
                      <FormattedMessage id='PRODUCT.QUICKACTIONS.DESC' />
                    </span>
                  </NavLink>
                  {/*  </a> */}
                </div>
                <div className='col-12'>
                  {/*     <a
                    href="#"
                    className="d-block py-10 px-5 text-center bg-hover-light border-right"
                  > */}
                  <NavLink
                    className='d-block py-10 px-5 text-center bg-hover-light border-bottom'
                    to='/sales/new'
                  >
                    <span className='svg-icon svg-icon-3x svg-icon-success'>
                      <SVG
                        src={toAbsoluteUrl(
                          '/media/svg/icons/Communication/Chat5.svg'
                        )}
                      ></SVG>
                    </span>
                    <span className='d-block text-dark-75 font-weight-bold font-size-h6 mt-2 mb-1'>
                      <FormattedMessage id='SALES.QUICKACTIONS.TITLE' />
                    </span>
                    <span className='d-block text-dark-50 font-size-sm'>
                      <FormattedMessage id='SALES.QUICKACTIONS.DESC' />
                    </span>
                  </NavLink>
                  {/*  </a> */}
                </div>
              </div>
            </form>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}
